module.exports = "/images/source-sans-pro-v11-cyrillic-ext_latin-600.svg";